module.exports = __webpack_public_path__ + "static/media/step-one-code.93a6e74c.png";